import React, { useEffect } from 'react'

import { useActionRunner } from 'src/modules/notification'

import { usePurchasing } from '../../hooks'

import ScheduledOrderList from './ScheduledOrderList'

const ScheduledOrderListView = () => {
  const {
    fetchScheduledOrderList,
    scheduledOrderList,
    purchasingEnvironment,
    updateScheduledOrderStatus,
  } = usePurchasing()
  const [doFetchScheduledOrderList, isFetching] = useActionRunner(
    fetchScheduledOrderList,
    {
      initialFetchingState: true,
    }
  )

  const [doUpdateScheduledOrderStatus] = useActionRunner(
    updateScheduledOrderStatus,
    {
      initialFetchingState: true,
    }
  )

  const onChangeScheduledOrderStatus = async (scheduledOrder, status) => {
    await doUpdateScheduledOrderStatus({
      id: scheduledOrder.id,
      draftOrderId: scheduledOrder.draftOrderId,
      status,
    })
    doFetchScheduledOrderList(purchasingEnvironment)
  }

  useEffect(() => {
    doFetchScheduledOrderList(purchasingEnvironment)
  }, [purchasingEnvironment])

  if (isFetching) {
    return null
  }

  console.log('outer', scheduledOrderList)
  return (
    <ScheduledOrderList
      orders={scheduledOrderList}
      onChangeScheduledOrderStatus={onChangeScheduledOrderStatus}
    />
  )
}

export default ScheduledOrderListView
